<template>
  <div>
    <div id="modal_endtour" class="modal fade end-tour" role="dialog">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header pl-0 d-flex">
            <p class="virtual-tour-header m-0 pl-16">{{$t('virtualTour')}}</p>
            <img src="/static/images/icons/virtualtour_close_icon.svg" class="success-close-btn" data-dismiss="modal" />
          </div>
          <div class="modal-body">
            <p class="modal-body-header">Conformity Declaration Management</p>
              <p class="complete-txt">{{ $t('congratulations') }}!</p>
              <p class="body-txt sub-text">{{ $t('successTourMsg1') }}</p>
          </div>
          <div class="modal-footer footer-img-section">
            <button type="button" class="btn end-tour-btn" data-dismiss="modal" @click="endTour()">
                {{ $t('closeTour') }}
              </button>
         </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from '../../utils/event-bus';

export default {
  methods: {
    endTour() {
      EventBus.$emit('tourEnd');
      EventBus.$emit('highlightNav', '/layout/dashboard');
      EventBus.$emit('CloseMobileSideNav');
    },
  },
};
</script>
<style scoped>
.end-tour .modal-dialog{
    width: 582px;
}
.virtual-tour-header {
  align-self: center;
  color: #1A1A1A;
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
}
.modal-body-header {
  color:#CA0123;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  padding-top: 24px;
  margin-bottom: 16px;
}
.modal-header{
  border-bottom: 1px solid #D3D3D3;
  height: 60px;
  background: #ffffff;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.modal-content{
  border-radius: 6px !important;
  background-color: #ffffff;
  max-height: 328px;
  width: 509px;
  margin: auto;
}
.modal-body{
  position: relative;
  padding: 0px 5px 29px 24px;
}
.modal-footer{
  background-color: #FAFAF9 !important;
  border-top: none;
  height: 76px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.sdc-logo{
  margin: 51px auto 35px auto;
  text-align: center;
  display: block;
  max-width: 100%;
  height: auto;
}
.text-center{
  text-align: center;
}
.success-close-btn{
  cursor:pointer;
  position: absolute;
  right: 21px;
  top: 23px;
  cursor: pointer;
}
.end-tour-btn,
.end-tour-btn:hover,
.end-tour-btn:focus{
  background-color: #01518A;
  border: none;
  cursor: pointer;
  color: #ffffff;
  line-height: 25px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  text-align: center;
  padding: 9.5px 16px;
}
.endtour-chkbox{
  text-align: center;
}
.chkbox-img{
  padding-top: 30px;
}
.sub-tour-txt{
  width: 400px;
}
.complete-txt{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  color: #000000;
  padding-bottom: 8px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.sub-text{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  color: #333333;
  margin: auto;
}
@media screen and (max-width: 767px) {
  .end-tour {
    display: none;
  }
}
</style>
